import { CheckIcon } from '@phosphor-icons/react'
import * as styles from './selection-summary.css.ts'

export type SelectionSummaryProps = {
  selectedCount: number
  onClear: () => unknown
}

/** "N selected" with a Clear link — shown in a dialog footer once something is picked. */
export const SelectionSummary: React.FC<SelectionSummaryProps> = ({ selectedCount, onClear }) => {
  // An empty span rather than null: the dialog footer is a flex row that pushes the buttons to its
  // end, and with nothing on the left they would slide across as soon as the selection cleared.
  if (selectedCount === 0) {
    return <span />
  }

  return (
    <span className={styles.container}>
      <span className={styles.group}>
        <CheckIcon size={24} weight="light" className={styles.icon} aria-hidden />
        <span className={styles.text}>
          <b className={styles.count}>{selectedCount}</b> selected
        </span>
      </span>
      <button type="button" className={styles.clear} onClick={onClear}>
        Clear
      </button>
    </span>
  )
}
